var s = document.createElement('style');
s.textContent = 'variant-picker.hide-unwanted-widebundle { display: block !important; } .block_dropdowns_wb, .title-option-wb, .general_option_label_wb { display: none !important; }';
document.head.appendChild(s);

function vifApplyGroup() {
  var mg = document.querySelector('media-gallery');
  if (!mg) return;
  var el = mg.querySelector('.js-data-variant-media');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch(x) { return; }
  if (!data || !data.media) return;
  var vp = document.querySelector('variant-picker');
  if (!vp) return;
  var opts = [];
  vp.querySelectorAll('fieldset').forEach(function(fs) {
    var r = fs.querySelector('input[type="radio"]:checked');
    if (r) opts.push(r.value);
  });
  var grp = opts[data.groupOptionIndex || 0];
  if (!grp) return;
  var ids = Object.keys(data.media).filter(function(k) { return data.media[k].group === grp; });
  if (!ids.length) return;
  mg.querySelectorAll('.slider__item[data-media-id]').forEach(function(item) {
    if (ids.indexOf(item.getAttribute('data-media-id')) !== -1) {
      item.removeAttribute('hidden');
    } else {
      item.setAttribute('hidden', '');
    }
  });
  mg.querySelectorAll('.slider__item.is-active').forEach(function(i) { i.classList.remove('is-active'); });
  var first = mg.querySelector('.slider__item[data-media-id="' + ids[0] + '"]');
  if (first) first.classList.add('is-active');
}

document.addEventListener('change', function(e) {
  if (e.target.tagName !== 'INPUT' || e.target.type !== 'radio' || !e.target.closest('variant-picker')) return;
  var val = e.target.value;
  document.querySelectorAll('select.discount_system_select_wb').forEach(function(sel) {
    var opt = Array.from(sel.options).find(function(o) { return o.value === val; });
    if (opt && sel.value !== val) {
      sel.value = val;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  var variantId = e.target.dataset.variantId;
  if (variantId) {
    var idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
    var vp = e.target.closest('variant-picker');
    var baseUrl = (vp && vp.dataset.url) || window.location.pathname;
    window.history.replaceState({}, '', baseUrl + '?variant=' + variantId);
  }
  setTimeout(vifApplyGroup, 0);
});

document.addEventListener('DOMContentLoaded', function() {
  var mg = document.querySelector('media-gallery');
  if (!mg) return;
  var p = Object.getPrototypeOf(mg);
  while (p && !p.hasOwnProperty('setMediaGroupOnFirstLoad')) {
    p = Object.getPrototypeOf(p);
  }
  if (!p || p._vifPatched) return;
  p._vifPatched = true;
  var origFn = p.setMediaGroupOnFirstLoad;
  p.setMediaGroupOnFirstLoad = function() {
    origFn.call(this);
    vifApplyGroup();
  };
  vifApplyGroup();
});

(function() {
  var _vifRapiPos = null;
  var _vifQOPatched = false;

  function getRapiPos() {
    var checked = document.querySelector('input[name^="rapi-bundles-deal-"]:checked');
    if (!checked) return null;
    var m = checked.id.match(/rapi-bundles-deal-(\d+)-/);
    return m ? parseInt(m[1], 10) : null;
  }

  function patchQuantityOffersInit() {
    if (_vifQOPatched) return;
    var qo = window._rsi && window._rsi.form && window._rsi.form.quantityOffers;
    if (!qo || typeof qo.init !== 'function') return;
    _vifQOPatched = true;
    var origInit = qo.init;

    qo.init = function(e) {
      var pos = _vifRapiPos;
      _vifRapiPos = null;

      if (pos !== null && pos !== undefined) {
        var qoRef = window._rsi && window._rsi.form && window._rsi.form.quantityOffers;
        try {
          if (qoRef && qoRef.savedSelection && qoRef.savedSelection.id) {
            qoRef.savedSelection.selectedPos = pos;
          } else if (qoRef && qoRef.currentOffer && qoRef.currentOffer.id) {
            var offers = qoRef.currentOffer.offers || [];
            qoRef.savedSelection = {
              id: qoRef.currentOffer.id,
              selectedPos: pos,
              offers: offers.map(function(o) {
                return { pos: o.pos, variants: o.variants ? o.variants.slice() : [] };
              })
            };
          }

          if (window._rsi && window._rsi.cart &&
              window._rsi.cart.items && window._rsi.cart.items.length === 1) {
            var correctQty = pos + 1;
            if (qoRef && qoRef.currentOffer && qoRef.currentOffer.offers) {
              for (var k = 0; k < qoRef.currentOffer.offers.length; k++) {
                if (qoRef.currentOffer.offers[k].pos === pos) {
                  correctQty = qoRef.currentOffer.offers[k].qty;
                  break;
                }
              }
            }
            window._rsi.cart.items[0].quantity = correctQty;
          }
        } catch (err) {}
      }

      return origInit.call(this, e);
    };
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('._rsi-buy-now-button');
    if (!btn) return;
    _vifRapiPos = getRapiPos();
    window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS_INTERNAL = null;
    patchQuantityOffersInit();
  }, true);
})();
